import Vue, { watch } from 'vue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import {mapGetters} from 'vuex'
/*import LoginForm from './_login-form.js'*/
import template from './index.pug'
import TransGC from './transGC'
import WawaJoven from './wawa'
import Bono from './bono'
import BonoOro from './bono-oro'
import LoginForm from 'js/components/layout-menu/_login-form.js'

const LOGIN = 'login'
const NAME = 'Gran Canaria'
const COMPONENT_NAME = 'info-cards-custom-gc'
const PAYMENT_MEDIAS = 'municipality-data-payment-medias'

export default Vue.extend({
  name: COMPONENT_NAME,
  template: template(),
  components: {
    LoginForm,
    VuePdfEmbed,
    TransGC,
    WawaJoven,
    Bono,
    BonoOro
  },

  data()  {
    return {
      onContinue: false,
      showPanel: false,
      //step: LOGIN,
      sidePanelOpen: true,
      selectedTabKey: 'all',
      tabsItems:  [
        {
          key:  'pdf',
          text:  Vue.i18n.t('info-cards.conditions.emissionRenovation'),
          route: { name: 'pdf' },
        },
          {
            key:  'transGN',
            text:  Vue.i18n.t('info-cards.conditions.transGN'),
            route: { name: 'trans-gc' },
        },
          {
            key:  'wawaGN',
            text:  Vue.i18n.t('info-cards.conditions.wawaGN'),
            route: { name: 'wawa' },
        },
          {
            key:  'bonoGN',
            text:  Vue.i18n.t('info-cards.conditions.bonoGN'),
            route: { name: 'bono' },
        },
        {
          key:  'bonoOroGN',
          text:  Vue.i18n.t('info-cards.conditions.bonoOroGN'),
          route: { name: 'bono-oro' },
        }
      ],
      step: '',
      tableData: [
        {
          alt: NAME,
          name: NAME,
          page: null,
          pdfSource: Vue.i18n.t('info-cards.url_file_information')
        }
      ],
      activeTab: 'pdf',
      pdfCache: {},
      currentPdfUrl: null
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    currentTabText()  {
        return Vue.i18n.t(`info-cards.conditions.${this.selectedTabKey}`)
    },
    // Get the PDF URL according to the current language
    pdfUrl() {
      return Vue.i18n.t('info-cards.url_file_information');
    },
    // Get the current 
    // language from 
    // Vue i18n
    currentLanguage() {
      return Vue.i18n.locale;
    }
  },

  watch: {
    currentUser(newValue) {
      // If the user is logged in, pressing the continue button
      // redirect them to the PAYMENT_MEDIAS.
      if (newValue && this.currentUser && this.onContinue === true) {
        this.$router.push({
          name: PAYMENT_MEDIAS
         // params: {country: this.country, municipality: this.municipality}
        })
      }
    },
    // Listen to changes
    // in the current language
    currentLanguage: {
      immediate: true,
      handler() {
        this.loadPdfForLanguage();
      }
    }
  },

  created() {
    window.scrollTo(0, 0)
  },

  methods: {
    // Checks if the user is logged in; if not, launches login.
    // If the user is logged in
    // redirect them to the PAYMENT_MEDIAS.
    continueBtn() {
      if (!this.currentUser) {
        this.onContinue = true
        this.login()
      } else {
        this.$router.push({
          name: PAYMENT_MEDIAS,
          params: {country: this.country, municipality: this.municipality}
        })
      }
    },

    tabChange(tabKey) {
    const tab = this.tabsItems.find(t => t.key === tabKey)
      if (tab && tab.route) {
      this.$router.push(tab.route)
    }
    this.selectedTabKey = tabKey
  },

    login() {
      this.changeStep(LOGIN)
      this.showPanel = true
    },

    changeStep(step) {
      this.step = step
    },

    closePanel() {
      this.showPanel = false
    },

    async loadPdfForLanguage() {
      const language = this.currentLanguage;

      // Check if the PDF is already
      // cached for the current language
      if (this.pdfCache[language]) {
        this.currentPdfUrl = this.pdfCache[language];
        return;
      }
      const response = await fetch(this.pdfUrl);
      const blob = await response.blob();

      // Create a temporary URL for the PDF
      // and store it in the cache
      const objectUrl = URL.createObjectURL(blob);
      this.pdfCache[language] = objectUrl;
      this.currentPdfUrl = objectUrl;
    },

    /**
     * Returns a translated text from i18n files
     * depending on the requested type ("conditions" or "details").
     * - For "conditions": returns the title of the active tab (with <br> removed).
     * - For "details": returns the general "Characteristics" label.
     *
     * @param {String} tab - Identifier of the active tab (e.g., 'tab1', 'tab2', etc.)
     * @param {String} [type='conditions'] - Type of text to translate ('conditions' or 'details').
     * @returns {String} Clean translated string.
     */
    getTranslatedLabel(tab, type = 'conditions') {
      // Mapping of tabs to their corresponding i18n keys
      const keyMap = {
        pdf: 'emissionRenovation',
        tab1: 'transGN',
        tab2: 'wawaGN',
        tab3: 'bonoGN',
        tab4: 'bonoOroGN'
      }

      // Case 1: "conditions" text based on the active tab
      if (type === 'conditions') {
        const key = keyMap[tab] || ''
        const fullKey = `info-cards.conditions.${key}`
        // Translate and remove any <br> tags
        return Vue.i18n.t(fullKey).replace(/<br\s*\/?>/gi, ' ')
      }

      // Case 2: General "details" or "characteristics" label
      if (type === 'details') {
        return Vue.i18n.t('info-cards.details.characteristics')
      }

      // Default return if the provided type doesn't match
      return ''
    }


  }
})